import { ThemeEvents } from '@theme/events';

// TL OVERRIDE: optimistic ATC pending
// Document-wide submit listener by design; loads after cart-drawer.js
const FAILSAFE_MS = 15000;
let pendingComponent = null;
let failsafeTimer = 0;

// Horizon owns button state
const endPending = (restoreButton) => {
  clearTimeout(failsafeTimer);
  if (pendingComponent) {
    pendingComponent.classList.remove('tl-atc-pending');
    pendingComponent.removeAttribute('aria-busy');
    if (restoreButton) pendingComponent.enable?.();
    pendingComponent = null;
  }
};

const startPending = (form) => {
  // release previous pending
  if (pendingComponent) endPending(true);
  const atcComponent =
    form.closest('product-form-component')?.querySelector('add-to-cart-component') ||
    form.querySelector('add-to-cart-component');
  const button = atcComponent?.querySelector('button[type="submit"]');
  // respect Horizon disabled
  if (!atcComponent || !button || button.disabled) return;

  // double-submit guard
  atcComponent.classList.add('tl-atc-pending');
  atcComponent.setAttribute('aria-busy', 'true');
  atcComponent.disable?.();
  pendingComponent = atcComponent;

  // open unless a modal blocks (add-ons may stack beneath)
  const drawer = document.querySelector('cart-drawer-component[auto-open]');
  const ownDialog = drawer?.querySelector('dialog');
  const blockingModal = Array.from(document.querySelectorAll('dialog[open]:not(.dialog-closing)')).some(
    (d) => d !== ownDialog && !d.classList.contains('tl-order-add-ons__drawer')
  );
  // empty check via rows
  const cartEmpty = !drawer?.querySelector('.cart-items__table-row');
  if (drawer && !blockingModal && !cartEmpty) {
    drawer.showDialog?.();
  }

  failsafeTimer = setTimeout(() => endPending(true), FAILSAFE_MS);
};

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!(form.getAttribute('action') || '').includes('/cart/add')) return;
    if (!form.closest('product-form-component')) return;
    // after Horizon submit
    queueMicrotask(() => startPending(form));
  },
  { capture: true }
);

document.addEventListener(ThemeEvents.cartUpdate, () => endPending(true));
document.addEventListener(ThemeEvents.cartError, () => {
  // cancel optimistic checkmark
  pendingComponent?.querySelector('[data-added]')?.removeAttribute('data-added');
  endPending(true);
});
document.addEventListener(ThemeEvents.variantUpdate, () => endPending(false));
